import Vue from "vue";

class QNotice {
  public success(data: any) {
    return Vue.notify({
      type: "brighttheme-success",
      classes: ["pnotify"],
      ...data,
    });
  }
  public error(data: any) {
    return Vue.notify({
      type: "brighttheme-error",
      ...data,
    });
  }
}

export default new QNotice();
